import { render, staticRenderFns } from "./NotExtendModual.vue?vue&type=template&id=36242a4e"
import script from "./NotExtendModual.vue?vue&type=script&lang=js"
export * from "./NotExtendModual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports